<!-- 文档发布目录树以后，专业角色权限树 -->
<template>
  <div>
    <el-tree ref="roletree" :data="roleList" :props="defaultRoleProps" :expand-on-click-node="false" node-key="roleId"
      highlight-current default-expand-all :filter-node-method="filterNode" @node-click="nodeClick">
      <template #default="{ data }">
        <div class="tree-content">
          <div style="display:flex;align-items:center;color:font-weight:400">
            <img :src="iconFn(data)" style="margin-right: 6px" alt="" />
            <span :title="data.roleName" class="textAll">{{ data.roleName }}</span>
          </div>
        </div>
      </template>
    </el-tree>
  </div>
</template>

<script>
import { mapState } from "vuex";
import docService from "@/CommonDP/service/doc-service";
import { storage } from "@/CommonDP/utils";
export default {
  props: {
    roleType: { type: String, required: false, default: "" },
    filterText: { type: String, required: false, default: "" }
  },
  data() {
    return {
      major_png: require("@/CommonDP/assets/settings/major.png"),
      role_png: require("@/CommonDP/assets/settings/systemRole.png"),
      spec_png: require("@/CommonDP/assets/settings/spec.png"),
      pm_png: require("@/CommonDP/assets/settings/pm.png"),
      customRole_png: require("@/CommonDP/assets/settings/customRole.png"),
      roleList: [],
      defaultRoleProps: {
        children: "childList",
        label: "roleName"
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    prjId() {
      return storage.get("updatePrjcook");
    }
  },
  watch: {
    filterText(val) {
      this.$refs.roletree.filter(val);
    }
  },
  created() {
    this.getTreeList();
  },
  methods: {
    filterNode(value, data, node) {
      if (!value) return true;
      if (data.roleName.indexOf(value) !== -1) {
        return true;
      }
      const level = node.level;
      if (level === 1) {
        return false;
      }
      let parentData = node.parent;
      let index = 0;
      while (index < level - 1) {
        if (parentData.data.roleName.indexOf(value) !== -1) {
          return true;
        }
        parentData = parentData.parent;
        index++;
      }
      return false;
    },
    async getTreeList() {
      this.roleList = [];
      const { prjId, enterpriseId, roleType } = this;
      const res = roleType ? await docService.getPrjSpecTreeNodList(prjId, enterpriseId, roleType) : await docService.queryRoleListNew(prjId, enterpriseId);
      this.roleList = [];
      if (!roleType) {
        res.data.roleId = res.data.prjId;
        res.data.roleName = res.data.prjName;
        res.data.$isOperation = 1;
        res.data.childList = res.data.childList.map((item) => {
          item.$isOperation = 1;
          item.roleId = item.specId;
          item.roleName = item.specName;
          return item;
        });
        this.roleList.push(res.data);
      } else {
        this.roleList = res.data.map((item) => {
          if (item.childList && item.childList.length > 0) {
            item.$isOperation = 1;
          }
          item.roleId = item.specId;
          item.roleName = item.specName;
          return item;
        });
      }
      if (this.roleList && this.roleList.length > 0) {
        if (this.roleType) {
          this.$nextTick(() => {
            if (this.$refs.roletree) this.$refs.roletree.setCurrentKey(this.roleList[0].roleId);
          });
          this.$emit("systemTableClick", this.roleList[0]);
        } else {
          const node = {
            data: this.roleList[0]
          };
          this.$emit("systemTableClick", [this.roleList[0], node]);
          this.$nextTick(() => {
            this.$refs.roletree.setCurrentKey(this.roleList[0].id);
          });
        }
      }
    },
    nodeClick(row, node) {
      if (this.roleType) this.$emit("systemTableClick", row, node);
      else this.$emit("systemTableClick", [row, node]);
    },
    iconFn(val) {
      if (this.roleType && this.roleType !== '1630981811371') {
        if (!val.$isOperation) {
          if (val.roleId === 'Sp_001' || val.roleId === 'Sp_002') {
            return this.spec_png;
          } else if (val.roleId === 'Sp_003') {
            return this.pm_png;
          } else {
            return this.role_png;
          }
        } else {
          return this.major_png;
        }
      } else if (this.roleType && this.roleType === '1630981811371') {
        if (!val.$isOperation) {
          return this.role_png;
        } else {
          return this.major_png;
        }
      } else {
        if (!val.$isOperation) {
          return this.role_png;
        } else {
          return this.major_png;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
</style>
